export const SET_API_JSON = 'SET_API_JSON'
export const SET_API_JSON_ERROR = 'SET_API_JSON_ERROR'
export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_PAGINATION = 'SET_PAGINATION'
export const SET_FLOOR_DATA = 'SET_FLOOR_DATA'
export const SET_BILLING_SERVICES_DATA = 'SET_BILLING_SERVICES_DATA'
export const SET_BILLING_PRODUCTS_DATA = 'SET_BILLING_PRODUCTS_DATA'
export const SET_BILLING_MEMBERSHIP_DATA = 'SET_BILLING_MEMBERSHIP_DATA'
export const SET_BILLING_PACKAGE_DATA = 'SET_BILLING_PACKAGE_DATA'
export const SET_COUPON__DATA = 'SET_COUPON__DATA'
export const SET_BILLIING_STATES__DATA = 'SET_BILLIING_STATES__DATA'
export const SET_BILLIING_SUMMRAY__DATA = 'SET_BILLIING_SUMMRAY__DATA'
export const SET_PAYMENT_METHOD__DATA = 'SET_PAYMENT_METHOD__DATA'
export const SET_BILLING__DATA = 'SET_BILLING__DATA'
export const SET_NO_GST__DATA = 'SET_NO_GST__DATA'
export const SET_UNPAID_AMT_DATA = "SET_UNPAID_AMT_DATA"
export const SET_QUESTIONS_DATA = "SET_QUESTIONS_DATA"
export const SET_SURVEY_DATA = "SET_SURVEY_DATA"
export const SET_SURVEY_RESPONSE_DATA = "SET_SURVEY_RESPONSE_DATA"
export const SET_PAYMENT_METHOD_RESPONSE__DATA = 'SET_PAYMENT_METHOD_RESPONSE__DATA'


// export const SET_CHILD_SERVICE_DATA = 'SET_CHILD_SERVICE_DATA'
export const SET_SERVICE_PAGINATION = 'SET_SERVICE_PAGINATION'
export const SET_GROUP_PAGINATION = 'SET_GROUP_PAGINATION'
export const SET_CLIENT_DATA = 'SET_CLIENT_DATA'

// export const SET_SELECTED_SERVICE ='SET_SELECTED_SERVICE'
// export const SET_CART_FLAG = 'SET_CART_FLAG'
// export const SET_BOOKING_DATE_AND_TIME = 'SET_BOOKING_DATE_AND_TIME'
// export const SET_SELECTED_SPECIALIST = 'SET_SELECTED_SPECIALIST'
// export const SINGLE_SPECIALIST_DATA = 'SINGLE_SPECIALIST_DATA'


export const SET_CLIENT_INFO = 'SET_CLIENT_INFO'
export const SET_SERVICE_INFO = 'SET_SERVICE_INFO'
export const SET_BILL_SUMMARY = 'SET_BILL_SUMMARY'
export const SET_BILLING_AUTOBILL_DATA = 'SET_BILLING_AUTOBILL_DATA'
export const SET_AUTOBILL_DATA = 'SET_AUTOBILL_DATA'
